// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"error-widget_subtitle__3ZT0g"};